import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";

const UploadLocalSystemFiles = ({ Show, Hide, Title, projectData, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [format, setFormat] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [title, setTitle] = useState("");

  const handleFormatChange = (format) => {
    setFormat(format);
    setUploadFile(null);
  };

  const cleanInputBox = () => {
    Hide();
    setFormat("");
    setTitle("");
    setUploadFile("");
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = files.filter((file) => {
      const csvType = file.type === "text/csv";
      const excelType =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      return (format === "csv" && csvType) || (format === "excel" && excelType);
    });

    if (validFiles.length === files.length) {
      setUploadFile(validFiles);
    } else {
      setUploadFile([]);
      alert(`Please select only ${format.toUpperCase()} files.`);
    }
  };

  const uploadLocalSystemFiles = async () => {
    if (uploadFile.length === 0) return;
    setButtonLoader(true);
    const formData = new FormData();
    const file = uploadFile[0];
    formData.append("savePath", projectData?.folderPath);
    formData.append("fileName", title);
    formData.append("file", file);
    const result = await editorProjectServices.uploadLocalSystemFiles(formData);
    if (result?.statusCode === 200) {
      cleanInputBox();
      getEditorProjectData();
      setUploadFile([]);
    }
    setButtonLoader(false);
  };

  const [error, setError] = useState("");

  const validatetitle = (input) => {
    const titleRegex = /^[a-zA-Z0-9_]+$/;

    if (!titleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Format{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleFormatChange(e.target.value)}
              value={format}
              required
            >
              <option value="">Select Format</option>
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Upload {format.toUpperCase()} File {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="file"
              disabled={!format}
              onChange={handleFileChange}
              accept={format === "csv" ? ".csv" : ".xls, .xlsx"}
              required
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Title {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter File Title"
              onChange={(e) => {
                setTitle(e.target.value);
                validatetitle(e.target.value);
              }}
              value={title}
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small
                letters, underScore and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={uploadLocalSystemFiles}
            disabled={buttonLoader || !format || !title || !uploadFile}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Uploading...
              </div>
            ) : (
              "Upload"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UploadLocalSystemFiles;
